import { Routes } from '@angular/router';
import { TaskConfigComponent } from './components/task-config/task-config.component';
import { CsvTaskConfigComponent } from './components/csv-task-config/csv-task-config.component';
import { FileTransferComponent } from './components/file-transfer/file-transfer.component';
import { FixedTaskConfigComponent } from './components/fixed-task-config/fixed-task-config.component';
import { JsonToFixedTaskConfigComponent } from './components/json-to-fixed-task-config/json-to-fixed-task-config.component';
import { NewMappingComponent } from './components/new-mapping/new-mapping.component';
import { MappingScreenComponent } from './components/mapping-screen/mapping-screen.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'config' },
  { path: 'config', component: TaskConfigComponent },
  { path: 'csv-config', component: CsvTaskConfigComponent },
  { path: 'fixed-config', component: FixedTaskConfigComponent },
  { path: 'json-to-fixed-config', component: JsonToFixedTaskConfigComponent },
  { path: 'new-mapping', component: NewMappingComponent },
  { path: 'mapping-screen', component: MappingScreenComponent },
  { path: 'transfer', component: FileTransferComponent },
  { path: '**', redirectTo: 'config' },
];
